import "../../new.scss";
import "./form.scss";
import { useParams, useNavigate } from 'react-router-dom';
import { useState, useContext, useEffect } from "react";
import { ZonasFormContext } from '../../../context/zonasentrega/ZonasContext';
import { ClientesZonasState } from '../../../context/clienteszonas/ClientesZonasState';
import DatatableDetalle from './clienteszonas/DatatableDetalle';
import ConfirmationDialog from "../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDialog";
import FormField from "../../../components/FormField/FormField";
import FormButtons from "../../../components/FormButtons/FormButtons";
import Inputs from "./configForm/inputs";
import { handleInputChange } from "./helpersForm/formHandlers";
import SucursalesModal from '../../sucursales/sucursalesModal/sucursalesModal';

export const Form = ({ title }) => {
  const [form, setForm] = useState({
    acepta_entregas: 1,
    activa: 1,
  });

  const {
    report,
    postZonaData,
    patchZonaData,
    detalleClientesData,
    addItemToArray,
    getItemFromArrayById,
    updateItemFromArray,
    removeItemFromArray,
    clearArray
  } = useContext(ZonasFormContext);

  const { id } = useParams();
  const navigate = useNavigate();

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFormFilled, setIsFormFilled] = useState(false);

  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // Estado para sucursal
  const [searchIdSucursal, setSearchIdSucursal] = useState();
  const [searchDescSucursal, setSearchDescSucursal] = useState('');

  const nameData = "zonas";

  // ═══════════════════════════════════════════════════════════════════════════
  // Cargar datos al editar
  // ═══════════════════════════════════════════════════════════════════════════
  useEffect(() => {
    if (report && Object.keys(report).length > 0) {
      setForm({
        ...report,
        nombre: report.nombre || "",
        descripcion: report.descripcion || "",
        radio_km: report.radio_km ?? "",
        latitud: report.latitud ?? "",
        longitud: report.longitud ?? "",
        monto_minimo: report.monto_minimo ?? "",
        costo_envio: report.costo_envio ?? "",
        envio_gratis_desde: report.envio_gratis_desde ?? "",
        limite_pedidos_dia: report.limite_pedidos_dia ?? "",
        horario_desde: report.horario_desde ?? "",
        horario_hasta: report.horario_hasta ?? "",
        dias_entrega: report.dias_entrega ?? "",
        tiempo_entrega: report.tiempo_entrega ?? "",
        acepta_entregas: report.acepta_entregas ?? 1,
        activa: report.activa ?? 1,
      });

      // Cargar sucursal
      if (report.suc_id) {
        setSearchIdSucursal(report.suc_id);
        setSearchDescSucursal(report.sucursal?.nombre || "");
      }

      setIsFormFilled(true);
    }
  }, [report]);

  // ═══════════════════════════════════════════════════════════════════════════
  // Sincronizar sucursal con form
  // ═══════════════════════════════════════════════════════════════════════════
  useEffect(() => {
    if (searchIdSucursal !== null && searchIdSucursal !== undefined && searchIdSucursal !== "") {
      setForm((prev) => ({ ...prev, suc_id: searchIdSucursal }));
      setErrors((prev) => ({ ...prev, suc_id: null }));
    } else if (!searchDescSucursal) {
      setForm((prev) => ({ ...prev, suc_id: null }));
    }
  }, [searchIdSucursal, searchDescSucursal]);

  // ═══════════════════════════════════════════════════════════════════════════
  // Validar formulario
  // ═══════════════════════════════════════════════════════════════════════════
  useEffect(() => {
    const isFilled = Inputs(id).every(({ name, validation }) => {
      if (!validation) return true;
      const value = form[name];
      return value !== null && value !== undefined && value !== "";
    });
    const hasErrors = Object.values(errors).some(v => v !== null && v !== "");
    setIsFormFilled(isFilled && !hasErrors && form.suc_id);
  }, [form, errors, id]);

  const handleChange = (e) => {
    handleInputChange(e, setForm, Inputs(id), setErrors, form);
  };

  const validateForm = () => {
    let formErrors = {};

    // Validar sucursal
    if (!form.suc_id) {
      formErrors.suc_id = "Debe seleccionar una sucursal.";
    }

    // Validar campos del formulario
    Inputs(id).forEach(({ name, validation, label }) => {
      if (validation) {
        const error = validation(form[name] || "", form);
        if (error) formErrors[name] = error;
      }
    });

    setErrors(formErrors);
    return !Object.keys(formErrors).length;
  };

  const openConfirmDialog = () => setIsConfirmDialogOpen(true);
  const closeConfirmDialog = () => setIsConfirmDialogOpen(false);

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };
  const closeErrorDialog = () => setIsErrorDialogOpen(false);

  const handleSendData = () => {
    if (!validateForm()) {
      const errorMessagesArray = [];
      
      if (errors.suc_id) {
        errorMessagesArray.push(`Sucursal: ${errors.suc_id}`);
      }

      Inputs(id).forEach(({ name, label }) => {
        if (errors[name]) {
          errorMessagesArray.push(`${label || name}: ${errors[name]}`);
        }
      });

      if (errorMessagesArray.length > 0) {
        openErrorDialog(errorMessagesArray);
      }
      return;
    }
    openConfirmDialog();
  };

  const confirmSendData = async () => {
    setIsSubmitting(true);
    closeConfirmDialog();

    try {
      if (id) {
        await patchZonaData(id, form);
      } else {
        await postZonaData(form);
      }
      navigate(`/${nameData}`);
    } catch (error) {
      console.error(error);
      openErrorDialog("Error al guardar los datos. Intenta nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(`/${nameData}`);
  };

  return (
    <div className="new">
      <div className="newContainer">
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            
            {/* ═══════════════════════════════════════════════════════════════════ */}
            {/* SECCIÓN: DATOS BÁSICOS */}
            {/* ═══════════════════════════════════════════════════════════════════ */}
            <div className="formZona__section formZona__section--basic">
              <div className="formZona__section-title">
                <span className="formZona__section-icon">📍</span>
                Datos de la Zona
              </div>
              <form className="formZona__grid formZona__grid--3cols">
                {/* Sucursal */}
                <div className="formInput">
                  <label>Sucursal *</label>
                  <SucursalesModal
                    handleChange={setSearchIdSucursal}
                    handleDescChange={setSearchDescSucursal}
                    descSelected={searchDescSucursal}
                    isEditing={id}
                  />
                  {errors.suc_id && <p className="error">{errors.suc_id}</p>}
                </div>

                {/* Campos de inputs */}
                {Inputs(id).slice(0, 5).map((input) => (
                  <FormField
                    key={input.id}
                    input={input}
                    placeholder={input.placeholder}
                    value={form[input.name] ?? ""}
                    handleInputChange={(e) => handleChange(e)}
                    error={errors[input.name]}
                  />
                ))}
              </form>
            </div>

            {/* ═══════════════════════════════════════════════════════════════════ */}
            {/* SECCIÓN: PRECIOS Y ENVÍO */}
            {/* ═══════════════════════════════════════════════════════════════════ */}
            <div className="formZona__section formZona__section--pricing">
              <div className="formZona__section-title">
                <span className="formZona__section-icon">💰</span>
                Precios y Envío
              </div>
              <form className="formZona__grid formZona__grid--3cols">
                {Inputs(id).slice(5, 8).map((input) => (
                  <FormField
                    key={input.id}
                    input={input}
                    placeholder={input.placeholder}
                    value={form[input.name] ?? ""}
                    handleInputChange={(e) => handleChange(e)}
                    error={errors[input.name]}
                  />
                ))}
              </form>
            </div>

            {/* ═══════════════════════════════════════════════════════════════════ */}
            {/* SECCIÓN: HORARIOS Y LÍMITES */}
            {/* ═══════════════════════════════════════════════════════════════════ */}
            <div className="formZona__section formZona__section--schedule">
              <div className="formZona__section-title">
                <span className="formZona__section-icon">🕐</span>
                Horarios y Límites
              </div>
              <form className="formZona__grid formZona__grid--4cols">
                {Inputs(id).slice(8, 13).map((input) => (
                  <FormField
                    key={input.id}
                    input={input}
                    placeholder={input.placeholder}
                    value={form[input.name] ?? ""}
                    handleInputChange={(e) => handleChange(e)}
                    error={errors[input.name]}
                  />
                ))}
              </form>
            </div>

            {/* ═══════════════════════════════════════════════════════════════════ */}
            {/* SECCIÓN: ESTADO */}
            {/* ═══════════════════════════════════════════════════════════════════ */}
            <div className="formZona__section formZona__section--status">
              <div className="formZona__section-title">
                <span className="formZona__section-icon">⚙️</span>
                Estado
              </div>
              <form className="formZona__grid formZona__grid--2cols">
                {Inputs(id).slice(13, 15).map((input) => (
                  <FormField
                    key={input.id}
                    input={input}
                    placeholder={input.placeholder}
                    value={form[input.name] ?? ""}
                    handleInputChange={(e) => handleChange(e)}
                    error={errors[input.name]}
                  />
                ))}
              </form>
            </div>

            {/* BOTONES */}
            <FormButtons
              isSubmitting={isSubmitting}
              handleSave={handleSendData}
              handleCancel={handleCancel}
              saveText="Guardar Zona"
              cancelText="Cancelar"
            />

            {/* ═══════════════════════════════════════════════════════════════════ */}
            {/* DETALLE: CLIENTES DE ESTA ZONA */}
            {/* ═══════════════════════════════════════════════════════════════════ */}
            {id && (
              <ClientesZonasState>
                <DatatableDetalle
                  zonaId={id}
                  arrayDetalle={detalleClientesData}
                  addItem={addItemToArray}
                  getItem={getItemFromArrayById}
                  updateItem={updateItemFromArray}
                  removeItem={removeItemFromArray}
                  clearArray={clearArray}
                  isCabComplete={isFormFilled}
                />
              </ClientesZonasState>
            )}

            <ConfirmationDialog
              isOpen={isConfirmDialogOpen}
              onClose={closeConfirmDialog}
              onConfirm={confirmSendData}
              title=""
              message="¿Estás seguro de que deseas guardar esta zona?"
            />
            <ErrorDialog
              isOpen={isErrorDialogOpen}
              onClose={closeErrorDialog}
              messages={errorMessage}
              title=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
